import * as React from 'react';

var useMediaQuery = function (mediaQuery) {
    var _a = React.useState(function () { return (typeof window === "undefined"
        ? true
        : window.matchMedia(mediaQuery).matches); }), isMatching = _a[0], setIsMatching = _a[1];
    React.useEffect(function () {
        var isMobileMedia = window.matchMedia(mediaQuery);
        var updateIsMobile = function (_a) {
            var matches = _a.matches;
            return setIsMatching(matches);
        };
        isMobileMedia.addListener(updateIsMobile);
        return function () { return isMobileMedia.removeListener(updateIsMobile); };
    }, [mediaQuery]);
    return isMatching;
};

export { useMediaQuery as u };
//# sourceMappingURL=useMediaQuery-f31e69fd.js.map
